// =============================================================================
// Accessors for the inline config PHP prints as `window.aiZippyChild`.
//
// Every endpoint, permalink and user-facing string the modules need comes from
// there rather than being written into a module, so moving a page or changing a
// translation is a PHP edit and never a rebuild.
//
// Each accessor tolerates the config being absent — the bundle also runs in the
// block editor's preview, where PHP never printed it — so a missing global
// degrades a module to doing nothing instead of throwing on every page.
// =============================================================================

const EMPTY = {};

/** The raw config object. */
export function cfg() {
	return window.aiZippyChild || EMPTY;
}

/**
 * A translated string by key.
 *
 * `fallback` is what the module uses when PHP did not supply the key, so a
 * module never prints `undefined` to a visitor.
 */
export function str(key, fallback = "") {
	const strings = cfg().strings || EMPTY;
	return typeof strings[key] === "string" ? strings[key] : fallback;
}

/** A page or endpoint URL by key. */
export function url(key, fallback = "/") {
	const value = cfg()[key];
	return typeof value === "string" && value ? value : fallback;
}
